import { InicioInstalacao } from "./InicioInstalacao";

export default InicioInstalacao;